export enum OrderProgressState {
  INIT = 'INIT',
  RESERVATION_WAITING = 'RESERVATION_WAITING',
  PURCHASE_INITIALIZED = 'PURCHASE_INITIALIZED',
  PAYMENT_CREATED = 'PAYMENT_CREATED',
  PAYMENT_PAID = 'PAYMENT_PAID',
  PURCHASE_PURCHASED = 'PURCHASE_PURCHASED',
  RESERVATION_CONFIRMED = 'RESERVATION_CONFIRMED',
  CONSULTATION_CREATED = 'CONSULTATION_CREATED',
  COMPLETED = 'COMPLETED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  PURCHASE_REJECTED = 'PURCHASE_REJECTED',
  RESERVATION_REJECTED = 'RESERVATION_REJECTED',
  FAILED = 'FAILED',
}

export interface OrderProgress {
  progressId: string
  state: OrderProgressState
  serviceOfferId: number
  reservationId?: number
  purchaseId?: number
  paymentId?: number
  consultationId?: number
  isFailure: boolean
}
